var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBusiness = function SvgBusiness(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 31,
    viewBox: "0 0 35 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5253 5.28076V4.46038C11.5253 3.13168 12.6063 2.05078 13.9349 2.05078H21.065C22.3936 2.05078 23.4746 3.13168 23.4746 4.46038V5.28076H25.5254V4.46038C25.5254 2.00088 23.5245 0 21.065 0H13.9349C11.4754 0 9.47455 2.00088 9.47455 4.46038V5.28076H11.5253Z",
    fill: "#8FAAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3748 18.4486L21.2548 22.0318V22.3587C21.2548 24.429 19.5704 26.1134 17.5001 26.1134C15.4297 26.1134 13.7454 24.429 13.7454 22.3587V22.0318L3.62537 18.4486C2.71434 18.126 1.88446 17.6564 1.15643 17.0741V30.7049H33.8437V17.074C33.1157 17.6564 32.2858 18.126 31.3748 18.4486Z",
    fill: "#8FAAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.33154V10.4173C0 13.1576 1.72662 15.6006 4.30979 16.5154L13.7453 19.8563V17.0442H21.2547V19.8562L30.6902 16.5153C33.2734 15.6006 35 13.1576 35 10.4173V7.33154H0Z",
    fill: "#8FAAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2039 19.0951H15.796V22.3586C15.796 23.2981 16.5604 24.0625 17.4999 24.0625C18.4395 24.0625 19.2039 23.2981 19.2039 22.3586V19.0951Z",
    fill: "#8FAAFF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBusiness, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/business.1812ea34.svg";
export { ForwardRef as ReactComponent };